const PermissionRoles = {
  VIEWER: 'Viewer',
  EDITOR: 'Editor',
  ADMIN: 'Admin',
} as const
export default PermissionRoles
